module.exports = __webpack_public_path__ + "media/2.7fb68df8.mp3";